import { render } from "./WhatsAppWidget.vue?vue&type=template&id=683baf80&scoped=true"
import script from "./WhatsAppWidget.vue?vue&type=script&lang=js"
export * from "./WhatsAppWidget.vue?vue&type=script&lang=js"

import "./WhatsAppWidget.vue?vue&type=style&index=0&id=683baf80&scoped=true&lang=css"

import exportComponent from "/Users/peter/projects/BhubCollege/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683baf80"]])

export default __exports__